/* eslint-disable jsx-a11y/no-onchange */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { trackPageInteraction } from "asos-contentweb-analytics-middleware";
import getConfig from "src/analyticsProvider/index";
import generateIcon from "src/app/utilities/generateIcon";
import truncateText from "src/app/utilities/truncateText";
import getTextWidthLimit from "src/app/utilities/getTextWidthLimit";
import Button from "../Button/Button";
import styles from "./Attachments.module.css";

const Attachments = ({ analytics, data }) => {
  const { items = [], text } = data;
  const [selectedAttachment, setSelectedAttachment] = useState(0);
  const [icon, setIcon] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [textWidthLimit, setTextWidthLimit] = useState(0);

  useEffect(() => {
    if (items.length) {
      const iconText = items[0].iconId?.text;
      setSelectedOption(items[selectedAttachment]?.text);
      setTextWidthLimit(getTextWidthLimit(window.innerWidth));
      setIcon(iconText ? generateIcon(iconText) : "");
    }
  }, []);

  if (!items.length) return items;

  const sendAnalytics = () => {
    const { category = "" } = analytics || {};
    const { itemName = "" } = items[selectedAttachment] || {};
    const articleDownloadConfig = getConfig("attachments-download", {
      category: category.toLowerCase(),
      itemName,
    });
    trackPageInteraction(articleDownloadConfig);
  };

  const onChangeHandler = (e) => {
    const index = e.target.selectedIndex;
    const iconText = items[index].iconId?.text;

    setSelectedAttachment(index);
    setIcon(iconText ? generateIcon(iconText) : "");
    setSelectedOption(items[index].text);
  };

  const buttonData = {
    text: text,
    link: {
      href: items[selectedAttachment].link?.href,
    },
    isCaps: true,
  };

  const classNames =
    icon.length > 0
      ? `${styles.attachmentsDropDown} ${styles.flagPadding}`
      : styles.attachmentsDropDown;

  return (
    <div className={styles.attachmentContainer}>
      <div className={styles.attachmentComponent}>
        <img
          className={styles.menuArrow}
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgMTAgNyI+CiAgICA8cGF0aCBmaWxsPSIjMkQyRDJEIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDMuNDE0TDcuODI4LjU4NiA5LjI0MyAyIDUgNi4yNDMgMy41ODYgNC44MjguNzU3IDIgMi4xNzIuNTg2IDUgMy40MTR6Ii8+Cjwvc3ZnPgo="
          alt=""
        />

        <select
          className={classNames}
          value={selectedOption}
          onChange={onChangeHandler}
          style={{ backgroundImage: "url(" + icon + ")" }}
          aria-label={data["aria-label"]?.text || null}
        >
          {items.map((item, i) => (
            <option
              key={`${item.text}-${i}`}
              value={item.text}
              aria-setsize={items.length}
              aria-posinset={i + 1}
            >
              {truncateText(item.text, textWidthLimit)}
            </option>
          ))}
        </select>

        <Button
          size="large"
          style="black"
          data={buttonData}
          onClick={sendAnalytics}
        />
      </div>
    </div>
  );
};

export default Attachments;

Attachments.propTypes = {
  page: PropTypes.string,
  data: PropTypes.shape({
    "items": PropTypes.array,
    "text": PropTypes.string,
    "aria-label": PropTypes.shape({
      text: PropTypes.string,
    }),
    "articleName": PropTypes.string,
  }),
  analytics: PropTypes.object,
};
